import { render, staticRenderFns } from "./OrderItemCompleteTimeline.vue?vue&type=template&id=b67b7602&"
import script from "./OrderItemCompleteTimeline.vue?vue&type=script&lang=js&"
export * from "./OrderItemCompleteTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports